export default {
  header: {
    title: 'Buy gift card',
  },
  items: {
    gift_card: {
      label: 'Gift card',
      title: 'Select your desired amount',
      description: 'Add the gift card with the desired quantity to the cart',
    },
    expiration: {
      label: 'Valid for 3 years',
      title: 'Enjoy gifting!',
      description: 'The recipient can redeem the voucher flexibly within 3 years.',
    },
    delivery: {
      label: 'Delivery immediately as a PDF via email',
      title: 'Instant delivery as a PDF via email',
      description: 'After secure payment by credit card, PayPal, or giropay, you will receive the voucher immediately.',
    },
  },
  form: {
    value: {
      title: 'Choose the gift card amount',
      custom: {
        label: 'Custom',
        placeholder: 'Enter amount',
      },
    },
    quantity: {
      title: 'Quantity',
    },
    email: {
      title: 'What is your email address so we can send you the gift card?',
      placeholder: 'Your email address',
    },
  },
  confirmation: {
    title: {
      title: 'Create gift card?',
      subtitle_one: 'Would you like to create 1 gift card for {{value}}?',
      subtitle_other: 'Would you like to create {{count}} gift cards for {{value}}?',
    },
    description: {
      total: 'Total:',
      email: 'E-Mail:',
      quantity: 'Quantity',
      amount: 'Amount',
    },
    footer: {
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
  },
  buttons: {
    create: 'Create',
  },
  toasts: {
    error: 'Creating gift card failed.',
    success: 'Gift card created successfully.',
  },
};
